import { roles, statusPrestationsValues, subRoles } from "../utils/constants";
import React from "react";
import { InterpretesList } from "../pages/Interpretes/InterpretesList/InterpretesList";
import { InstitutionDetail } from "../pages/Institutions/InstitutionDetail/InstitutionDetail";
import { PrestationsList } from "../pages/Prestations/PrestationsList/Prestations.list";
import { Login } from "../pages/Auth/login/Login";
import PublicRegister from "../pages/Auth/PublicRegister/PublicRegister";
import { PasswordLost } from "../pages/Auth/PasswordLost/PasswordLost";
import { PasswordReset } from "../pages/Auth/PasswordReset/PasswordReset";
import { DefaultRouteRole } from "./AuthRoute";
import MainLayout from "../layouts/MainLayout";
import { PrestationDetail } from "../pages/Prestations/PrestationDetail/Prestation.detail";
import { PrestationInformations } from "../pages/Prestations/PrestationInformations/PrestationInformations";
import { PrestationBilling } from "../pages/Prestations/PrestationBilling/PrestationBilling";
import { PrestationInterpretes } from "../pages/Prestations/PrestationInterpretes/Prestation.interpretes";
import { PrestationResume } from "../pages/Prestations/PrestationResume/PrestationResume";
import { InstitutionUsers } from "../pages/Institutions/InstitutionUsers/Institution.users";
import { InstitutionsList } from "../pages/Institutions/InstitutionsList/Institutions.list";
import { InstitutionUser } from "../pages/Institutions/InstitutionUser/Institution.user";
import {
  BillingCrumb,
  BreadcrumbsLink,
  InstitutionCrumb,
  InstitutionUserCrumb,
  InterpretesCrumb,
  PrestationCrumb,
  PrincipalCrumb,
  UsersCrumb,
} from "../shared/components/Breadcrumbs/Breadcrumbs";
import { InterpreteSchedule } from "../pages/Interpretes/InterpreteSchedule/InterpreteSchedule";
import { InterpreteDetail } from "../pages/Interpretes/InterpreteDetail/InterpreteDetail";
import { PrincipalDetail } from "../pages/Principals/PrincipalDetail/PrincipalDetail";
import { PrincipalUsers } from "../pages/Principals/PrincipalUsers/PrincipalUsers";
import { PrincipalUser } from "../pages/Principals/PrincipalUser/PrincipalUser";
import { Principalslist } from "../pages/Principals/PrincipalsList/Principalslist";
import { PrincipalInstitutions } from "../pages/Principals/PrincipalInstitutions/PrincipalInstitutions";
import { InstitutionAddresses } from "../pages/Institutions/InstitutionAddresses/InstitutionAddresses";
import { PrestationAnswerYes } from "../pages/Prestations/PrestationAnswerYes/PrestationAnswerYes";
import { PrincipalAddresses } from "../pages/Principals/PrincipalAddresses/PrincipalAddresses";
import { LogDetail } from "../pages/Logs/LogDetail/LogDetail";
import { LogsList } from "../pages/Logs/LogsList/Logs.list";
import { BillDetail } from "../pages/Billing/BillDetail/BillDetail";
import { BillEdit } from "../pages/Billing/BillEdit/BillEdit";
import { BillingList } from "../pages/Billing/BillingList/BillingList";
import { InstitutionLocations } from "../pages/Institutions/InstitutionLocations/InstitutionLocations";
import { UsersList } from "../pages/Users/UsersList/users.list";
import { UserDetail } from "../pages/Users/userDetail/user.detail";
import { InstitutionResponsables } from "../pages/Institutions/InstitutionResponsables/InstitutionResponsables";
import { i18n } from "engine/context/AppProviders";
import { PrestationSelector } from "../pages/Prestations/PrestationSelector/Prestation.selector";
import { t } from "i18next";

const routes = {
  root: () => {
    const path = "/";
    const title = t("routes.home");

    return {
      path,
      title,
      index: {
        path,
        title,
        element: <MainLayout />,
        all: 1,
      },
      main: {
        path,
        index: true,
        element: <DefaultRouteRole />,
        title,
        all: 1,
      },
    };
  },
  prestations: (_id = ":id") => {
    const path = "prestations";
    const title = i18n.t("header.prestations");

    const {
      draft,
      planned,
      finish,
      cancel,
      cancelAvic,
      cancelInterprete,
      cancelClient,
      waiting,
      finish_permanance,
      finish_notsigned,
    } = statusPrestationsValues;

    const ressourceCrumbs = () => {
      return <BreadcrumbsLink to={path} title={title} />;
    };

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <PrestationCrumb route={route} />,
      title,
      path,
      new: {
        path: `/${path}/new`,
        title: t("routes.newPrestation"),
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud",
          [subRoles.institutionDemander]: "crud",
        },
      },
      selector: {
        path: `/${path}/${_id}/selector`,
        element: <PrestationSelector />,
        title: t("routes.creationByInterprete"),
        visibility: { status: [draft], edit: false },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud",
          [subRoles.institutionDemander]: "crud",
        },
        fallBack: params => {
          return `/${path}/${params}`;
        },
      },
      detail: {
        element: <PrestationDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.prestationDetails1"),
        visibility: { status: [draft], edit: true },
        fallBack: params => {
          if (params === "new") {
            return `/`;
          }

          return `/${path}/${params}/resume`;
        },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [subRoles.institutionDemander]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
      },
      detailInterpretes: {
        fallBack: params => `/${path}/${params}`,
        visibility: { status: [draft, waiting], edit: true },
        disabled: { step: "searchInterpretes" },
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [subRoles.institutionDemander]: "crud", // Create Read Update Delete
        },
        path: `/${path}/${_id}/interpretes`,
        title: ({ status, dangerousUpdate }) => {
          return status === statusPrestationsValues.draft || dangerousUpdate
            ? t("routes.prestationInterpretes2")
            : t("routes.prestationInterpretes");
        },
        element: <PrestationInterpretes />,
      },
      detailResume: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "cr", // Create Read Update Delete
          [subRoles.institutionDemander]: "cr", // Create Read Update Delete
          [roles.permanance]: "crud",
          [roles.interprete]: "r",
        },
        fallBack: params => {
          if (params === "new") {
            return `/`;
          }

          return `/${path}/${params}`;
        },
        disabled: { step: "resume" },
        path: `/${path}/${_id}/resume`,
        title: ({ status, dangerousUpdate }) => {
          return status === statusPrestationsValues.draft || dangerousUpdate
            ? t("routes.prestationRecap4")
            : t("routes.prestationDetails");
        },
        element: <PrestationResume />,
      },
      detailInformations: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
        element: <PrestationInformations />,
        disabledOnNew: true,
        visibility: { status: [draft], edit: true },
        disabled: { step: "complements" },
        fallBack: params => `/${path}/${params}`,
        path: `/${path}/${_id}/informations`,
        title: t("routes.prestationAddedInformation3"),
      },
      confirmAnswerYes: {
        path: `/${path}/${_id}/success`,
        element: <PrestationAnswerYes />,
        all: 1,
      },
      detailBilling: {
        visibility: {
          status: [
            finish,
            planned,
            cancelClient,
            cancelAvic,
            cancel,
            finish_permanance,
            finish_notsigned,
          ],
          edit: true,
        },
        element: <PrestationBilling />,
        step: "facturation",
        path: `/${path}/${_id}/billing`,
        title: t("routes.prestationBillingOrder"),
        fallBack: params => `/${path}/${params}`,
        only: {
          [subRoles.institutionFinance]: "r", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud",
        },
      },
      list: {
        index: true,
        // Title of link
        title: i18n.t("header.prestations"),
        // Path being used
        path: `/${path}`,
        element: <PrestationsList />,
        crumb: ressourceCrumbs,

        // Rules should be all OR only. Not both

        // Only level access 2 or more can access it
        // All defined a direct easy full access depending the level of the user
        // all: 1,

        // Specific roles can access to the ressource
        //  only: [roles.institutionAdmin], // Specific
        only: {
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [subRoles.institutionIntervenant]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
          [roles.interprete]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  interpretes: (_id = ":id") => {
    const path = "interpretes";
    const title = t("routes.interpretes");

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <InterpretesCrumb route={route} />,
      path,
      detail: {
        element: <InterpreteDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.interpreteDetails"),
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.interprete]: "crud", // Create Read Update Delete
        },
      },
      detailSchedule: {
        all: 1,
        disabled: { onNew: true },
        element: <InterpreteSchedule />,
        path: `/${path}/${_id}/schedules`,
        title: t("routes.interpreteAvailabilities"),
      },
      myAccount: {
        path: `/${path}/${_id}`,
        title: t("routes.interpreteMyAccount"),
        only: {
          [roles.interprete]: "crud", // Create Read Update Delete
        },
      },
      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <InterpretesList />,
        title: i18n.t("header.interpretes"),
        path: `/${path}`,
        all: 4,
      },
      new: {
        path: `/${path}/new`,
        title: t("routes.interpreteNewInterprete"),
        all: 1,
      },
    };
  },
  users: (_id = ":id") => {
    const path = "users";
    const title = "Utilisateurs";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <UsersCrumb route={route} />,
      path,
      detail: {
        element: <UserDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.userDetails"),
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <UsersList />,
        title: i18n.t("header.utilisateurs"),
        path: `/${path}`,
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      new: {
        path: `/${path}/new`,
        title: t("routes.userNewUser"),
        only: {
          [roles.admin]: "rud", // Create Read Update Delete
          [roles.permanance]: "rud", // Create Read Update Delete
        },
      },
    };
  },
  billing: (_id = ":id") => {
    const path = "billing";
    const title = "Facturation";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <BillingCrumb route={route} />,
      path,
      detail: {
        element: <BillDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.billingDetails"),
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [subRoles.institutionFinance]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      edition: {
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
        },
        disabled: { onNew: true },
        element: <BillEdit />,
        path: `/${path}/${_id}/edit`,
        title: t("routes.billingEdit"),
      },
      list: {
        crumb: route => <BreadcrumbsLink to={`/${path}`} title={title} />,
        element: <BillingList />,
        title: i18n.t("header.facturation"),
        path: `/${path}`,
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [subRoles.institutionFinance]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  institutions: (_id = ":id") => {
    const path = "institutions";
    const title = "Institutions";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <InstitutionCrumb route={route} />,
      title,
      path,
      detail: {
        element: <InstitutionDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.institutionDetails"),
        only: {
          [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.permanance]: "crud", // Create Read Update Delete
          [subRoles.institutionFinance]: "r", // Create Read Update Delete
          [subRoles.institutionDemander]: "r", // Create Read Update Delete
        },
      },
      myInstitution: {
        element: <InstitutionDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.institutionMyInstitution"),
        only: {
          [roles.institution]: "crud", // Create Read Update Delete
        },
      },
      addresses: {
        disabled: { onNew: true },
        element: <InstitutionAddresses />,
        path: `/${path}/${_id}/addresses`,
        title: t("routes.institutionAddressBilling"),
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
          [subRoles.institutionFinance]: "r", // Read
        },
      },
      locations: {
        disabled: { onNew: true },
        element: <InstitutionLocations />,
        path: `/${path}/${_id}/locations`,
        title: t("routes.institutionAddressPrestation"),
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
        },
      },
      responsables: {
        disabled: { onNew: true },
        element: <InstitutionResponsables />,
        path: `/${path}/${_id}/responsables`,
        title: t("routes.institutionResponsableMeeting"),
        only: {
          [roles.permanance]: "crud", // Create Read Update Delete
          [roles.admin]: "crud", // Create Read Update Delete
          [subRoles.institutionAdmin]: "r", // Read
          [subRoles.institutionDemander]: "r", // Read
        },
      },
      detailUsers: {
        element: <InstitutionUsers />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/users`,
        title: t("routes.institutionUsers"),
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud", // Create Read Update Delete
          [roles.institution]: "r", // Create Read Update Delete
          [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
        },
      },
      newUserInstitution: (user = ":user") => {
        return {
          element: <InstitutionUser isNew={true} />,
          disabled: { onNew: true },
          crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: t("routes.institutionNewUser"),
          only: {
            [roles.permanance]: "crud",
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "crud", // Create Read Update Delete
            [subRoles.institutionAdmin]: "r", // Create Read Update Delete
          },
        };
      },
      detailUser: (user = ":user") => {
        return {
          element: <InstitutionUser />,
          disabled: { onNew: true },
          crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: t("routes.institutionUser"),
          only: {
            [roles.permanance]: "crud",
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "r", // Create Read Update Delete
            [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          },
        };
      },

      detailIntervenants: {
        all: 1,
        path: `/${path}/${_id}/intervenants`,
        title: t("routes.institutionIntervenants"),
      },
      list: {
        element: <InstitutionsList />,
        title: i18n.t("header.institutions"),
        path: `/${path}`,
        all: 4,
      },
      new: {
        path: `/${path}/new`,
        title: t("routes.institutionNewInstitution"),
        only: {
          [roles.permanance]: "crud",
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  principals: (_id = ":id") => {
    const path = "principals";
    const title = "Mandants globaux";

    return {
      ressourceCrumb: route => (
        <BreadcrumbsLink to={`/${path}`} title={title} />
      ),
      crumb: route => <PrincipalCrumb route={route} />,
      title,
      path,
      detail: {
        element: <PrincipalDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.mandantDetails"),
        only: {
          // [roles.admin]: "crud", // Create Read Update Delete
          // [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      myPrincipal: {
        element: <PrincipalDetail />,
        path: `/${path}/${_id}`,
        title: t("routes.mandantMyAccount"),
        only: {
          // [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      detailUsers: {
        element: <PrincipalUsers />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/users`,
        title: t("routes.mandantUsers"),
        only: {
          // [roles.admin]: "crud", // Create Read Update Delete
          // [roles.permanance]: "crud", // Create Read Update Delete
          // [roles.mandant]: "crud", // Create Read Update Delete
        },
      },
      addresses: {
        disabled: { onNew: true },
        element: <PrincipalAddresses />,
        path: `/${path}/${_id}/addresses`,
        title: t("routes.mandantAddressBilling"),
        // all: 3,
      },

      detailInstitutions: {
        all: 1,
        element: <PrincipalInstitutions />,
        disabled: { onNew: true },
        path: `/${path}/${_id}/institutions`,
        title: t("routes.mandantInstitutions"),
        only: {
          // [roles.admin]: "crud", // Create Read Update Delete
          // [roles.permanance]: "crud", // Create Read Update Delete
        },
      },
      detailUser: (user = ":user") => {
        return {
          element: <PrincipalUser />,
          disabled: { onNew: true },
          // crumb: route => <InstitutionUserCrumb route={route} />,
          path: `/${path}/${_id}/users/${user}`,
          title: t("routes.mandantUser"),
          only: {
            [roles.admin]: "crud", // Create Read Update Delete
            [roles.institution]: "crud", // Create Read Update Delete
            [subRoles.institutionAdmin]: "crud", // Create Read Update Delete
          },
        };
      },
      list: {
        element: <Principalslist />,
        title: i18n.t("header.mandants"),
        path: `/${path}`,
        // all: 100,
        only: {},
      },
      new: {
        path: `/${path}/new`,
        title: t("routes.mandantNewMandantGlobal"),
        only: {},
      },
    };
  },
  user: (_id = ":id") => {
    const path = "user";
    // Utilisateur
    return {
      detail: `/${path}/${_id}?tab=informations`,
      list: `/${path}`,
      new: `/${path}/new`,
    };
  },
  logs: (_id = ":id") => {
    const path = "logs";
    const title = "Logs";

    // log de l'app
    return {
      list: {
        element: <LogsList />,
        path: `/${path}`,
        title: i18n.t("header.logs"),
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
      detail: {
        element: <LogDetail />,
        path: `/${path}/${_id}`,
        title: "Détail du log",
        only: {
          [roles.admin]: "crud", // Create Read Update Delete
        },
      },
    };
  },
  auth: () => {
    const path = "auth";
    // log de l'app
    return {
      path,
      login: {
        element: <Login />,
        index: true,
        path: `/${path}`,
        title: "Login",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      register: {
        element: <PublicRegister />,
        path: `/${path}/register`,
        title: "Register",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      reset: {
        element: <PasswordReset />,
        path: `/${path}/reset`,
        title: "reset",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
      lost: {
        element: <PasswordLost />,
        path: `/${path}/lost`,
        title: "lost",
        only: {
          [roles.ghost]: "crud", // Create Read Update Delete
        },
      },
    };
  },
};

export default routes;
